import { UilEllipsisV } from "@iconscout/react-unicons";
import { useState } from "react";
import { Trash2, Edit } from "react-feather";
import { useRecoilState } from "recoil";
import { ModalTypeState, SelectedCanvasState } from "../../atoms";
import { CanvasListDto } from "../../services";
import { ModalTypes } from "../modal";

type Props = {
  canvas: CanvasListDto;
};

export function CanvasActionButton({ canvas }: Props) {
  const [selectedCanvas, setSelectedCanvas] =
    useRecoilState<CanvasListDto | null>(SelectedCanvasState);
  const [, setModalType] = useRecoilState(ModalTypeState);
  const [showOption, setShowOption] = useState(false);

  const selectCanvas = () => {
    if (showOption) {
      setSelectedCanvas(null);
      setShowOption(false);
    } else {
      setSelectedCanvas(canvas);
      setShowOption(true);
    }
  };

  const handleDeleteClick = () => {
    setModalType(ModalTypes.DeleteCanvasModal);
  };

  const handleEditClick = () => {
    setModalType(ModalTypes.UpdateCanvasModal);
  };

  const handleOnBlur = () => {
    setShowOption(false);
  };

  return (
    <div className="relative" tabIndex={1} onBlur={handleOnBlur}>
      <UilEllipsisV className="cursor-pointer" onClick={selectCanvas} />
      {selectedCanvas?.id === canvas.id && showOption && (
        <div
          className={`absolute top-1 z-10 right-4 rounded-md border border-page-border bg-dropdown min-w-max cursor-pointer`}
        >
          <ul className=" max-h-64 rounded-md overflow-auto scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-transparent">
            <li>
              <label
                className="flex items-center rounded-md gap-2 p-2.5  cursor-pointer hover:bg-button-bg-primary-hover"
                onClick={handleEditClick}
              >
                <Edit className="w-4 first-letter:text-gray-200" />
                <span>Update</span>
              </label>
            </li>
            <li>
              <label
                className="flex items-center rounded-md gap-2 p-2.5  text-button-bg-destructive-default cursor-pointer hover:bg-button-bg-primary-hover"
                onClick={handleDeleteClick}
              >
                <Trash2 className="w-4" />
                <span>Delete</span>
              </label>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}
